"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useState, type JSX } from "react";
import ProxyActionRowDataMode from "./ProxyActionRowDataMode";
import CommonChangeAnimation from "@/components/utils/animation/CommonChangeAnimation";
import ProfileProxyCreditEdit from "../action/utils/credit/ProfileProxyCreditEdit";
import ProfileProxyEndTimeEdit from "../action/utils/time/ProfileProxyEndTimeEdit";
export enum PROXY_ACTION_ROW_VIEW_MODE {
  DATA = "DATA",
  CREDIT_EDIT = "CREDIT_EDIT",
  END_TIME_EDIT = "END_TIME_EDIT",
}
export default function ProxyActionRow(t0) {
  const $ = _c(20);
  const {
    action,
    profileProxy,
    profile,
    isSelf
  } = t0;
  const [viewMode, setViewMode] = useState(PROXY_ACTION_ROW_VIEW_MODE.DATA);
  let t1;
  if ($[0] !== action || $[1] !== isSelf || $[2] !== profile || $[3] !== profileProxy) {
    t1 = <ProxyActionRowDataMode action={action} profileProxy={profileProxy} profile={profile} isSelf={isSelf} setViewMode={setViewMode} />;
    $[0] = action;
    $[1] = isSelf;
    $[2] = profile;
    $[3] = profileProxy;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setViewMode(PROXY_ACTION_ROW_VIEW_MODE.DATA);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== action || $[7] !== profileProxy) {
    t3 = <ProfileProxyCreditEdit profileProxy={profileProxy} profileProxyAction={action} setViewMode={t2} />;
    $[6] = action;
    $[7] = profileProxy;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setViewMode(PROXY_ACTION_ROW_VIEW_MODE.DATA);
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== action || $[11] !== profileProxy) {
    t5 = <ProfileProxyEndTimeEdit profileProxy={profileProxy} profileProxyAction={action} setViewMode={t4} />;
    $[10] = action;
    $[11] = profileProxy;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t1 || $[14] !== t3 || $[15] !== t5) {
    t6 = {
      [PROXY_ACTION_ROW_VIEW_MODE.DATA]: t1,
      [PROXY_ACTION_ROW_VIEW_MODE.CREDIT_EDIT]: t3,
      [PROXY_ACTION_ROW_VIEW_MODE.END_TIME_EDIT]: t5
    };
    $[13] = t1;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const components = t6;
  const t7 = components[viewMode];
  let t8;
  if ($[17] !== action.id || $[18] !== t7) {
    t8 = <div className="tw-rounded-lg tw-ring-1 tw-ring-inset tw-ring-iron-600"><CommonChangeAnimation key={action.id}>{t7}</CommonChangeAnimation></div>;
    $[17] = action.id;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}